import React from 'react';
import { CheckIcon, DownloadIcon, PrinterIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-brand-green-50 via-white to-white pt-8 pb-10 px-5 overflow-hidden" data-id="element-103">
      {/* Soft decorative blob */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-brand-cream-100/40 rounded-full blur-3xl -z-0" aria-hidden="true" data-id="element-104" />
      <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-brand-green-100/50 rounded-full blur-3xl -z-0" aria-hidden="true" data-id="element-105" />

      <div className="relative max-w-2xl mx-auto text-center" data-id="element-106">
        {/* Small trust pill */}
        <div className="inline-flex items-center gap-2 bg-white border border-brand-green-100 rounded-full px-3 py-1.5 mb-6 shadow-soft" data-id="element-107">
          <span className="flex h-2 w-2 rounded-full bg-brand-green-500" data-id="element-108"></span>
          <span className="text-xs font-semibold text-brand-green-700" data-id="element-109">
            Acceso inmediato por email
          </span>
        </div>

        <h1 className="font-sans text-3xl sm:text-4xl md:text-5xl font-extrabold leading-[1.15] text-brand-ink tracking-tight" data-id="element-110">
          100 actividades listas para estimular y entretener a tu hijo{' '}
          <span className="highlight-yellow" data-id="element-111">sin pantallas</span>
        </h1>

        <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl mx-auto" data-id="element-112">
          Imprimí el kit en casa y empezá a jugar en menos de 5 minutos.
          Diseñado para niños de 0 a 5 años.
        </p>

        {/* Product image */}
        <a href="https://impulsodigital.vip/cart/44763616936022:1" className="block mx-auto max-w-sm sm:max-w-md mt-8 group" data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/2k39vYiaBdNTWpr6TBPDrc/ChatGPT_Image_21_may_2026,_14_42_02.png" alt="Crecer Jugando — Kit imprimible de 100 actividades" className="w-full rounded-3xl shadow-soft-lg transition-transform duration-300 group-hover:-translate-y-1" data-id="element-114" />
        </a>

        {/* Price block */}
        <div className="mt-8 inline-flex flex-col items-center bg-white border border-slate-100 rounded-2xl px-6 py-5 shadow-soft" data-id="element-115">
          <div className="flex items-baseline gap-3" data-id="element-116">
            <span className="text-sm text-slate-400 line-through" data-id="element-117">$49.990</span>
            <span className="text-xs font-bold text-brand-green-600 bg-brand-green-50 px-2 py-0.5 rounded-full" data-id="element-118">
              60% OFF
            </span>
          </div>
          <div className="mt-1 font-extrabold text-4xl sm:text-5xl text-brand-ink tracking-tight" data-id="element-119">
            $19.990{' '}
            <span className="text-base font-semibold text-slate-500" data-id="element-120">ARS</span>
          </div>
          <p className="mt-1 text-xs text-slate-500" data-id="element-121">
            Pago único · sin suscripción
          </p>
        </div>

        {/* CTA */}
        <div className="mt-6" data-id="element-122">
          <CTAButton text="Sí, quiero el kit completo" data-id="element-123" />
        </div>

        {/* Trust line */}
        <div className="mt-5 flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-xs sm:text-sm text-slate-500 font-medium" data-id="element-124">
          <span className="flex items-center gap-1.5" data-id="element-125">
            <DownloadIcon className="w-4 h-4 text-brand-green-500" data-id="element-126" /> Acceso
            inmediato
          </span>
          <span className="flex items-center gap-1.5" data-id="element-127">
            <SmartphoneIcon className="w-4 h-4 text-brand-green-500" data-id="element-128" /> Celular
            · Tablet · PC
          </span>
          <span className="flex items-center gap-1.5" data-id="element-129">
            <PrinterIcon className="w-4 h-4 text-brand-green-500" data-id="element-130" /> PDF
            imprimible
          </span>
        </div>
      </div>
    </section>;
}